import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import AdminAutoConfirmationSettingsPanel from './AdminAutoConfirmationSettingsPanel';
import AdminOrderDisputesPanel from './AdminOrderDisputesPanel';
import AdminOrderCompletionPanel from './AdminOrderCompletionPanel';

const findOrdersPanel = () => {
  const heading = Array.from(document.querySelectorAll('h3'))
    .find((element) => element.textContent.trim() === 'Advanced Audit Filters');

  return heading?.parentElement?.parentElement?.parentElement || null;
};

const AdminOrdersTabPanels = () => {
  const [hosts, setHosts] = useState({ top: null, bottom: null });

  useEffect(() => {
    let frame = 0;

    const syncHosts = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const ordersPanel = findOrdersPanel();

        if (!ordersPanel) {
          setHosts((current) => (
            current.top?.isConnected || current.bottom?.isConnected
              ? { top: null, bottom: null }
              : current
          ));
          return;
        }

        let top = ordersPanel.querySelector('[data-orders-tools-top]');
        let bottom = ordersPanel.querySelector('[data-orders-tools-bottom]');

        if (!top) {
          top = document.createElement('div');
          top.dataset.ordersToolsTop = '';
          ordersPanel.prepend(top);
        }

        if (!bottom) {
          bottom = document.createElement('div');
          bottom.dataset.ordersToolsBottom = '';
          ordersPanel.append(bottom);
        }

        setHosts((current) => (
          current.top === top && current.bottom === bottom
            ? current
            : { top, bottom }
        ));
      });
    };

    const observer = new MutationObserver(syncHosts);
    observer.observe(document.body, { childList: true, subtree: true });
    syncHosts();

    return () => {
      cancelAnimationFrame(frame);
      observer.disconnect();
    };
  }, []);

  if (!hosts.top?.isConnected || !hosts.bottom?.isConnected) return null;

  return (
    <>
      {createPortal(<AdminAutoConfirmationSettingsPanel />, hosts.top)}
      {createPortal(
        <>
          <AdminOrderDisputesPanel />
          <AdminOrderCompletionPanel />
        </>,
        hosts.bottom
      )}
    </>
  );
};

export default AdminOrdersTabPanels;
